import i18n from '@/i18n'
import BlankLayout from '../../layout/blankLayout.vue'
import JobPostList from './list.vue'
import HistoryList from './pointChangeHistory.vue'

const pathPrefix = '/v-admin/client-admin/job-board-point-dashboard'

const routes = [
  {
    name: 'clientAdminJobBoardPointDashboardIndex',
    path: `${pathPrefix}/index`,
    component: JobPostList,
    meta: {
      titleI18nKey: '',
      menu: {
        get label () {
          return i18n.t('admin.company.jobBoardPointDashboard.menu.index')
        }
      },
      get title () {
        return i18n.t('admin.company.jobBoardPointDashboard.title.index')
      }
    }
  },
  {
    name: 'clientAdminJobBoardPointDashboardHistory',
    path: `${pathPrefix}/history/:companyId`,
    component: HistoryList,
    meta: {
      titleI18nKey: 'admin.company.jobBoardPointDashboard.title.history',
      menu: {
        get label () {
          return i18n.t('admin.company.jobBoardPointDashboard.menu.history')
        },
        hiddenInNewLayout: true,
        get title () {
          return i18n.t('admin.company.jobBoardPointDashboard.title.history')
        }
      }
    }
  }
]

const jobBoardPointRoute = {
  name: 'clientAdminJobBoardPointDashboard',
  path: `${pathPrefix}`,
  component: BlankLayout,
  redirect: `${pathPrefix}/index`,
  meta: {
    permission: ['PERM_COMPANY_APPROVAL'],
    titleI18nKey: '',
    menu: {
      get label () {
        return i18n.t('admin.company.jobBoardPointDashboard.menu.index')
      }
    },
    get title () {
      return i18n.t('admin.company.jobBoardPointDashboard.title.index')
    },
    isAllInclude: true,
    isNewPage: true
  },
  children: routes
}

export default jobBoardPointRoute
